import { createContext, useContext } from 'react'
import { Client } from '@/services/index'

interface AppClientProviderType {
  children: React.ReactNode
  client: ReturnType<typeof Client>
}

const ApiContext = createContext<{
  client: ReturnType<typeof Client> | null
}>({
  client: null,
})

export function AppClientProvider({ children, client }: AppClientProviderType) {
  const value = {
    client,
  }

  return <ApiContext.Provider value={value}>{children}</ApiContext.Provider>
}

export function useClient() {
  return useContext(ApiContext).client
}
